export enum ThemeColor {
  /**
   * èè²
   */
  BLUE = 'BLUE',

  /**
   * ç»¿è²
   */
  GREEN = 'GREEN'
}
